import { render, staticRenderFns } from "./CreateAnamneseBlock.vue?vue&type=template&id=6133a93c&scoped=true"
import script from "./CreateAnamneseBlock.vue?vue&type=script&lang=js"
export * from "./CreateAnamneseBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6133a93c",
  null
  
)

export default component.exports